module.exports = __webpack_public_path__ + "static/media/galerija_2023 (16).423a3c7d.png";